import React, { FC, useEffect, useRef } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import { getCarriersListFetch } from 'src/resources/carriersList/reducer';
import { RootStoreType } from 'src/types/store';
import TableSimple from 'src/components/TableSimple';
import { ExportTypeType, TableRefType } from 'src/types/table';
import { allColumns } from './constants';
import TopBlock from './TopBlock';
import { useCheckPermission } from 'src/utils/checkPermission';
import StoreIcon from '@mui/icons-material/Store';
import { editUserSettingsFetch } from 'src/resources/userSettings/reducer';
import { UserSettingsType } from 'src/types/userSettings';

const CarriersListContainer: FC = () => {
  const dispatch = useDispatch();
  const tableRef = useRef<TableRefType>();

  const loading = useSelector((state: RootStoreType) => state.carriersList.loading);
  const carriersData = useSelector((state: RootStoreType) => state.carriersList.data) || [];
  const shipperCodes = useSelector((state: RootStoreType) =>
    [...state.constantsCodes.data.shipperCodes].sort((a, b) => a.label.localeCompare(b.label))
  );
  const userSettingsData = useSelector((state: RootStoreType) => state.userSettings.data);

  const permissionCreate = useCheckPermission('CARRIER.CREATE');
  const permissionList = useCheckPermission('CARRIER.LIST');

  useEffect(() => {
    dispatch(setLocationParams({ name: translate('carriers.title') }));
    dispatch(getCarriersListFetch());
  }, []);

  const reloadCarriersList = () => {
    dispatch(getCarriersListFetch());
  };

  const handleExport = (type: ExportTypeType) => {
    tableRef.current?.exportTable(type, translate('carriers.action.exportFileName'));
  };

  const editUserSettings = (newUserSettings: UserSettingsType) => {
    dispatch(editUserSettingsFetch(newUserSettings));
  };

  return (
    <>
      <TopBlock
        reloadCarriersList={reloadCarriersList}
        permissionCreate={permissionCreate}
        handleExport={handleExport}
      />
      <TableSimple
        tableRef={tableRef}
        rowIdKey="ID"
        rows={carriersData}
        loading={loading}
        columsLabelPrefix="carriers.table"
        allColumns={allColumns}
        initSort={{ column: 'SHIPPER', direction: 'ASC' }}
        fullHeight
        heightVariant="top-tab-2"
        optionsSessionName="carriersTable"
        userSettingsName="showCarriersTableColumns"
        userSettingsData={userSettingsData}
        editUserSettings={editUserSettings}
        selectOptions={{ shipperCodes }}
        rowActions={[
          {
            icon: <StoreIcon />,
            label: translate('carriers.action.carrierDetail'),
            getLink: (row) => `/admin/carriers/${row.ID}/`,
            hiddenFce: () => !permissionList,
          },
        ]}
      />
    </>
  );
};

export default CarriersListContainer;
